/** Datum YYYY-MM-DD kao lokalni Date (bez pomeranja zbog vremenske zone), ili null. */
export const parseDay = (iso) => {
  const [year, month, day] = String(iso || "")
    .split("-")
    .map(Number);
  return year ? new Date(year, month - 1, day) : null;
};

/** "pon 19. 10." – dan u nedelji i datum, da se red prepozna bez računanja. */
export const formatDayLabel = (iso, locale) => {
  const date = parseDay(iso);
  if (!date) {
    return String(iso || "");
  }
  const weekday = new Intl.DateTimeFormat(locale, { weekday: "short" }).format(date).replace(/\.$/, "");
  const short = new Intl.DateTimeFormat(locale, { day: "numeric", month: "numeric" }).format(date);
  return `${weekday} ${short}`;
};
